import { EnumFeatureFlagName } from '@blank/api'
import { useAuthenticatedUserQuery } from 'modules/auth/queries/useAuthenticatedUserQuery'
import { useCorporateUserName } from 'modules/corporate/hooks/useCorporateUserName'
import { useCorporateOfferQuery } from 'modules/corporate/queries/useCorporateOfferQuery'
import { useFeatureFlagQuery } from 'modules/corporate/queries/useFeatureFlagQuery'

export const useHomePageQueries = () => {
  const { data: authenticatedUser } = useAuthenticatedUserQuery()

  const { data: corporateOffer, isSuccess } = useCorporateOfferQuery(
    authenticatedUser?.corporateId
  )

  // Prefetch instant payment feature flag
  useFeatureFlagQuery(EnumFeatureFlagName.INSTANT_PAYMENTS)
  useFeatureFlagQuery(EnumFeatureFlagName.INSTANT_PAYMENTS_ITALIA)

  const { firstName } = useCorporateUserName()

  return {
    data: { corporateOffer, firstName },
    isSuccess,
  }
}
